module.exports = __webpack_public_path__ + "media/images/unemployed_active-3b28abf1.svg";